import React, {PureComponent} from 'react';
import autobind from 'autobind-decorator';
import {FormControl, FormGroup} from 'react-bootstrap';

export class EnvironmentalBenefitFilter extends PureComponent {
    @autobind
    updateValue(x) {
        const { UpdateValue } = this.props;

        if(UpdateValue) {
            UpdateValue?.(x?.target?.value);
        }
    }

    render() {
        const { Value, HideUnselectedOption, EnvironmentalBenefits } = this.props;
        const placeholder = "Benefit Type";

        let valueOrFirst = Value || "";

        if(valueOrFirst !== "" && !EnvironmentalBenefits.find((x) => x.environmentalBenefitId == valueOrFirst)) {
            valueOrFirst = EnvironmentalBenefits[0]?.environmentalBenefitId ?? "";
        }

        return <FormGroup controlId="formControlsSelect">
            <FormControl
                as="select"
                placeholder={placeholder}
                value={valueOrFirst}
                onChange={this.updateValue}
            >
                {
                    !HideUnselectedOption ?
                        <option value={""}>{placeholder}</option>:
                        null
                }
                {
                    EnvironmentalBenefits.map(x =>
                        <option
                            key={x?.environmentalBenefitId}
                            value={x?.environmentalBenefitId}
                        >
                            {x?.name}
                        </option>
                    )
                }
            </FormControl>
        </FormGroup>
    }
}


